import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import CommissionTool from "./CommissionTool";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-commission-tool")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<CommissionTool />
		</ThemeProvider>
	</StrictMode>
);
